import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';

import { Stack } from '@chakra-ui/react';

import { getElementSize } from './utils';

interface IFullHeight {
  children(height: number, width: number): string | ReactNode;
}

export const WithParentSize: FC<IFullHeight> = props => {
  const { children, ...rest } = props;

  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const el: any = ref.current;
    if (!el) return;

    const updateDimension = () => {
      const size = getElementSize(el);
      setHeight(size.height);
      setWidth(size.width);
    };

    const observer = new ResizeObserver(updateDimension);
    observer.observe(el);
    updateDimension();
    return () => observer.disconnect();
  }, []);

  return (
    <Stack ref={ref} spacing={0} h={'full'} w={'full'} {...rest}>
      {children(height, width)}
    </Stack>
  );
};
